export default __webpack_public_path__ + "static/B0038-ca112e7549bd1e5fafaf6e642145d78b.png";